import { Platform } from "react-native";
import { match } from "ts-pattern";

export const MONEY_VALUES_MULTIPLIER = 100;
export const TIME_DURATION_MULTIPLIER = 3600000;
export const DAYS_DURATION_MULTIPLIER = 86400000;
export const DEFAULT_DECIMAL_SEPARATOR = ",";
export const PHONE_COUNTRY_CODE = {
  Poland: "+48",
  Norway: "+47",
};

export enum API_URLS {
  Production = "api.stepapp.pl",
  Staging = "api.stepapp.ovh",
}

export enum ADMIN_API_URLS {
  Production = "sapi.stepapp.pl",
  Staging = "sapi.stepapp.ovh",
}

export enum LinksPL {
  AboutUs = "https://stepapp.pl/nasze-cele/",
  AppLanding = "https://stepapp.pl/aplikacja-do-sprzatania/",
  AppCustomer = "https://onelink.to/8tnjup",
  AppWorker = "https://onelink.to/65pwd2",
  BecomeWorker = "https://stepapp.pl/zostan-wykonawca",
  Blog = "https://stepapp.pl/porady/",
  CancellationRules = "https://stepapp.pl/zasady-anulowania",
  Contact = "https://stepapp.pl/kontakt",
  FAQ = "https://stepapp.pl/faq/",
  Home = "https://stepapp.pl/",
  Intercom = "https://intercom.help/stepapp/pl",
  Method = "https://stepapp.pl/metoda-stepapp/",
  Myths = "https://stepapp.pl/mity/",
  PrivacyPolicy = "https://stepapp.pl/polityka-prywatnosci",
  ProposeCity = "https://stepapp.pl/zaproponuj-miasto",
  Reviews = "https://stepapp.pl/opinie/",
  StepCover = "https://stepapp.pl/stepcover",
  TermsOfUse = "https://stepapp.pl/warunki-korzystania",
  Verification = "https://intercom.help/stepapp/pl/articles/8474202-jak-weryfikujemy-panie-sprzatajace-top-5",
  WorkerBonusRules = "https://stepapp.pl/worker/zasady-premii",
  Workers = "https://stepapp.pl/osoby-sprzatajace/",
  WorkerFiles = "https://drive.google.com/drive/folders/1zY0RMRhfsZZQcmPiVJoZGpgWdteAr-oF?usp=sharing",
}

export enum LinksNO {
  AboutUs = "https://stephome.no/om-oss/",
  AppLanding = "https://stephome.no/app/",
  AppCustomer = "https://onelink.to/8tnjup",
  AppWorker = "https://onelink.to/65pwd2",
  BecomeWorker = "https://stephome.no/rengjoringsarbeid/",
  Blog = "https://stephome.no/blogg",
  CancellationRules = "https://stephome.no/bruksvilkar/",
  Contact = " https://stephome.no/kontakt/",
  FAQ = "https://stephome.no/faq/",
  Home = "https://stephome.no/",
  Intercom = "https://intercom.help/stepapp/pl",
  Method = "https://stepapp.pl/metoda-stepapp/",
  Myths = "",
  PrivacyPolicy = "https://stephome.no/personvern/",
  ProposeCity = "https://stephome.no/foresla-by",
  Reviews = "https://stephome.no/",
  StepCover = "https://stephome.no/insurance",
  TermsOfUse = "https://stephome.no/bruksvilkar/",
  Verification = "https://intercom.help/stepapp/pl/articles/8474202-jak-weryfikujemy-panie-sprzatajace-top-5",
  WorkerBonusRules = "",
  Workers = "https://stephome.no/rengjoringspersonale/",
  WorkerFiles = "https://drive.google.com/drive/folders/1zY0RMRhfsZZQcmPiVJoZGpgWdteAr-oF?usp=sharing",
}

export enum ContactPL {
  Email = "support@stepapp.pl",
  Phone = "",
  AppUrl = "https://app.stepapp.pl/",
  LandingPageUrl = "www.stepapp.pl",
}

export enum ContactNO {
  Email = "support@stephome.no",
  Phone = "+47 40 05 60 40",
  AppUrl = "https://app.stephome.no/",
  LandingPageUrl = "www.stephome.no",
}

export const getLinks = (countryCode: string) => {
  return match(countryCode)
    .with("NO", () => LinksNO)
    .otherwise(() => LinksPL);
};

function isMobile() {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return regex.test(navigator.userAgent);
}

export function getContactDetails(countryCode: string) {
  return match(countryCode)
    .with("NO", () => ContactNO)
    .otherwise(() => ContactPL);
}

export const isWeb = Platform.OS === "web";
export const isAndroid = Platform.OS === "android";
export const isIOS = Platform.OS === "ios";
export const isNative = isAndroid || isIOS;
export const isMobileDevice = isMobile();

export const BACKEND_ERROR = {
  PaymentRequiresAction: "urn:problem:payment_requires_action",
  Unauthenticated: "UNAUTHENTICATED",
};

export const NoSubscriptionOptionInBundle = "OVERRIDE_SUBSCRIPTION";
